import React from "react";
import styles from "./header.module.scss";

const FALLBACK_GREETING = "Hi Zingbus Traveller!";
const GREETING_AVATAR =
  "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/userImage_1789014612243.svg";
const CLOSE_ICON =
  "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/close_1789014612242.svg";

// The app draws its own close control around the WebView.
const isInWebView = () =>
  typeof window !== "undefined" &&
  !!(window.ReactNativeWebView || window.AndroidWebView);

const MAX_GREETING_NAME_LENGTH = 20;

const isNumericOnly = value => /^[0-9]+$/.test(value);

const getGreetingName = booking => {
  const fullName = booking?.tripChart?.[0]?.name;
  if (typeof fullName !== "string") {
    return FALLBACK_GREETING;
  }

  const trimmed = fullName.trim();
  if (!trimmed || isNumericOnly(trimmed.replace(/\s+/g, ""))) {
    return FALLBACK_GREETING;
  }

  // Truncate at 20 characters with an ellipsis and no "!". Array.from splits
  // by code point so emoji / surrogate pairs aren't cut in half.
  const chars = Array.from(trimmed);
  if (chars.length <= MAX_GREETING_NAME_LENGTH) {
    return `${trimmed}!`;
  }
  return `${chars.slice(0, MAX_GREETING_NAME_LENGTH).join("").trimEnd()}…`;
};

const Header = props => {
  const { booking, updateNote } = props;
  if (
    booking.showselfHelpComment &&
    booking.selfHelpCommentRelayTime &&
    booking.selfHelpCommentRelayTime - Date.now() > 0
  ) {
    setTimeout(
      () => updateNote(booking),
      booking.selfHelpCommentRelayTime - Date.now()
    );
  } else if (
    booking.showselfHelpComment &&
    booking.selfHelpCommentRelayTime &&
    booking.selfHelpCommentRelayTime - Date.now() < 0
  ) {
    updateNote(booking);
  }

  const greetingName = getGreetingName(booking);
  const isMaxService = booking?.trip?.service?.isMaxService;

  return (
    <div id="header" className={styles.header}>
      <div className={isMaxService ? styles.greetingMaxx : styles.greeting}>
        <div className={styles.greetingUser}>
          <img className={styles.avatar} src={GREETING_AVATAR} alt="" />
          <div className={styles.greetingText}>
            <span className={styles.hello}>Hello</span>
            <span className={styles.name}>{greetingName}</span>
          </div>
        </div>
        {isInWebView() ? null : (
          <img
            className={styles.close}
            src={CLOSE_ICON}
            alt="close"
            onClick={() => window.history.back()}
          />
        )}
      </div>
    </div>
  );
};

export default Header;
